<template lang="pug">
	.simple-audio-loader.flex-col.space-large.tb-padding
		.flex-row.space-large
			.flex-col.field.center(v-if="!$auth.isAdvertiser()")
				.font-small.upper.grey {{$tCaption('Advertiser')}}
				Dropdown(
					:getTotal="(data) => null", :getItems="(data) => data.Results", :getData="(a,b,c) => $Data.getExternalCompanies(a,b, {...(c || {}), byType: 0, forceTokenAuth: c.byKey ? false : null })",
					:columns="[{ dataField: 'Name', caption: $tCaption('Advertiser') }]",
					displayExpr="Name",
					valueExpr="Oid",
					:selectedItems="creative.Advertiser && creative.Advertiser.Oid",
					:showColumnHeaders="false",
					:filtersVisible="false",
					:searchVisible="true",
					:multiple="false",
					:minSearchLength="0",
					:disabled="!!isLoading",
					@select-data="item => creative.Advertiser = item")
			.flex-col.field.center(v-if="!$auth.isAgency()")
				.font-small.upper.grey {{$tCaption('Agency')}}
				Dropdown(
					:getTotal="(data) => null", :getItems="(data) => data.Results", :getData="(a,b,c) => $Data.getExternalCompanies(a,b, {...(c || {}), byType: 2, forceTokenAuth: c.byKey ? false : null })",
					:columns="[{ dataField: 'Name', caption: $tCaption('Agency') }]",
					displayExpr="Name",
					valueExpr="Oid",
					:selectedItems="creative.Agency && creative.Agency.Oid",
					:showColumnHeaders="false",
					:filtersVisible="false",
					:searchVisible="true",
					:multiple="false",
					:minSearchLength="0",
					:disabled="!!isLoading",
					@select-data="item => creative.Agency = item")
			.flex-row.space-large(v-if="!hasFinalAudio")
				FileUploader(ref="finalAudioUploader", :text="$tCaption('Upload audio file')", :isUIHidden="false", :isLoading="!!isLoading", @file-selected="fileUploading.selected = true" @upload="onNewCreativeFileUpload", dropText="Or drop audio files here to upload")
					.flex-row.space-large.lr-padding(v-if="fileUploading.selected")
						.flex-row.space.align-center
							DxCheckBox(:value.sync="fileUploading.trim", :text="$tCaption('Trim')")
							DxNumberBox(v-show="fileUploading.trim", :value.sync="fileUploading.trimDbLevel", format="#0.## dB", :width="80", :show-spin-buttons="true", :step="0.1")
						.flex-row.space.align-center
							DxCheckBox(:value.sync="fileUploading.normalize", :text="$tCaption('Normalize')")
							DxNumberBox(v-show="fileUploading.normalize", :value.sync="fileUploading.normalizeDbLevel", format="#0.## dB", :width="80", :show-spin-buttons="true", :step="1")
				Loader(v-if="isLoading", :text="$tCaption('Processing, please wait') + '..'")
			.flex-row.space-large(v-else)
				.flex-col.center
					.font-small.upper.grey  {{$tCaption('File name')}}
					span {{$azure.getReadableFileName(creative.FinalAudio.FileName)}}
				.flex-col.center
					.font-small.upper.grey  {{$tCaption('Duration')}}
					span {{Math.ceil(creative.Duration / 1000) || 0}} {{$tCaption('seconds')}}
		.flex-row.space(v-if="hasFinalAudio")
			DxButton(:text="$tCaption('Download')", icon="download", @click="downloadFile", :disabled="!!isLoading")
			FileUploader(ref="finalAudioUploader", :text="$tCaption('Reupload audio file')", icon="refresh", :isLoading="!!isLoading", :isUIHidden="false", @file-selected="fileUploading.selected = true" @upload="onNewCreativeFileUpload", dropText="Or drop audio files here to upload")
				.flex-row.space-large.lr-padding(v-if="fileUploading.selected")
					.flex-row.space.align-center
						DxCheckBox(:value.sync="fileUploading.trim", :text="$tCaption('Trim')")
						DxNumberBox(v-show="fileUploading.trim",:value.sync="fileUploading.trimDbLevel", format="#0.## dB", :width="80", :show-spin-buttons="true", :step="0.1")
					.flex-row.space.align-center
						DxCheckBox(:value.sync="fileUploading.normalize", :text="$tCaption('Normalize')")
						DxNumberBox(v-show="fileUploading.normalize", :value.sync="fileUploading.normalizeDbLevel", format="#0.## dB", :width="80", :show-spin-buttons="true", :step="1")
			Loader(v-if="isLoading", :text="$tCaption('Processing, please wait') + '..'")
		.flex-row(v-if="creative && creative.IsSimple === false")
			.attention
				span {{$tCaption('The creative is displayed in a simplified form because your Creative Studio subscription has expired.')}}
</template>

<script>
	import $ from 'jquery';
	import _ from 'lodash';
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxTextArea from 'devextreme-vue/text-area';
	import DxNumberBox from 'devextreme-vue/number-box';
	import DxCheckBox from 'devextreme-vue/check-box';
	import FileUploader from 'app-core/FileUploader.vue';
	import Promise from 'bluebird';
	import Loader from 'app-core/Loader.vue';
	import storage from 'storage';
	import Dropdown from 'app-core/Dropdown.vue';

	export default {
		translationCategory: 'creative.SimpleAudioLoader',
		name: 'creative-detail',
		components: {
			DxButton, DxTextBox, DxTextArea, DxNumberBox, FileUploader, DxCheckBox, Loader, Dropdown
		},
		props: ['creative'],
		data() {
			return {
				isLoading: 0,
				fileUploading: {
					trim: false,
					trimDbLevel: storage.prop('audio-tracker-trim-silence-db-level').value || 0.1,
					normalize: false,
					normalizeDbLevel: storage.prop('audio-tracker-normalize-db-level').value || -3,
					selected: false
				}
			};
		},
		mounted() {
			if (__DEBUG__)
				window.simpleAudioLoader = this;
		},
		computed: {
			hasFinalAudio() {
				return this.creative && this.creative.FinalAudio && this.creative.FinalAudio.FileName
			}
		},
		watch: {
			'creative.Advertiser.Oid'() {
				this.$emit('save-creative');
			},
			'creative.StationOwner.Oid'() {
				this.$emit('save-creative');
			},
			'creative.Agency.Oid'() {
				this.$emit('save-creative');
			}
		},
		methods: {
			downloadFile() {
				this.isLoading++;
				this.$azure.getCreativeFinalAudio(this.creative, true).then(r => {
					var objUrl = URL.createObjectURL(new Blob([r], { type: 'audio/wav' }));
					var link = document.createElement('a');
					link.href = objUrl;
					link.download = this.creative.FinalAudio.FileName;
					link.click();
				}).finally(() => this.isLoading--);
			},
			onNewCreativeFileUpload(v) {
				if (__DEBUG__)
					console.debug('onNewCreativeFileUpload', v);
				var fr = new FileReader;
				fr.readAsDataURL(v[0]);
				fr.onloadend = () => {
					this.onNewBase64FileData(fr.result, v[0].name);
				};
			},
			onNewBase64FileData(base64, fileName) {
				var audio = new Audio();
				audio.src = base64;
				audio.addEventListener('loadedmetadata', () => {
					var duration = audio.duration;
					var name = `${fileName}`.split('.').slice(0, -1).join('.') || fileName;
					this.creative.Duration = parseFloat(duration * 1000);
					this.$emit('save-creative', this.creative);

					if (__DEBUG__)
						console.debug('Audio locally loaded', { audio, creative: this.creative, base64 });

					var uploadAudio = (creative, base64, customFileName) => {
						return new Promise((mainResolve, mainReject) => {
							if (__DEBUG__)
								console.debug('Upload creative audio', { base64 });
							var ext = this.$Data.getBase64AudioExtension(base64);
							var toolPromise = (method, dbLevel, condition, audioBase64) => new Promise(resolve => {
								if (condition) {
									var data = audioBase64.split(';base64,')[1];
									var ext = this.$Data.getBase64AudioExtension(audioBase64);
									this.isLoading++;
									this.$Data.postExternalApi(`audio/${method}`, {
										MediaExtension: ext,
										DbLevel: dbLevel,
										Base64Content: data
									}, {
										xhr: () => {
											var xhr = new XMLHttpRequest();
											xhr.responseType= 'blob';
											return xhr;
										},
										processData: false,
										dataType: 'binary'
									}).then(r => {
										if (r.Success !== false) {
											var fr1 = new FileReader;
											fr1.onloadend = () => {
												if (__DEBUG__)
													console.debug(`${method} result on file upload`, { r: fr1.result });
												resolve(fr1.result);
											};
											fr1.readAsDataURL(r);
										} else {
											resolve(audioBase64);
										}
									}).catch(() => {
										resolve(audioBase64);
									}).finally(() => this.isLoading--);
								} else {
									resolve(audioBase64);
								}
							});

							toolPromise('TrimAudio', this.fileUploading.trimDbLevel, this.fileUploading.trim, base64).then(r1 => {
								toolPromise('NormalizeAudio', this.fileUploading.normalizeDbLevel, this.fileUploading.normalize, r1).then(r2 => {
									var ext = this.$Data.getBase64AudioExtension(r2);
									this.isLoading++;
									this.$azure.uploadCreativeFinalAudio(this.creative, r2, customFileName)
										.then((r3) => {
											mainResolve(r3);
											if (__DEBUG__)
												console.debug('Final audio creative uploaded', { r2 });
										})
										.catch((ex) => {
											mainReject(ex);
										})
										.finally(() => this.isLoading--);
									return r2;
								});
								return r1;
							});
						});
					};

					this.isLoading++;
					uploadAudio(this.creative, base64, name).catch(ex => this.$notifyError(ex)).finally(() => this.isLoading--);
				}, false);
			}
		}
	};
</script>
<style lang='scss'>
	.simple-audio-loader {
		.attention {
			padding: 20px;
			background: #fb6464;
			color: #ffcbcb;
		}
	}
</style>
